import { render, staticRenderFns } from "./GestionAccidenteIncidente.vue?vue&type=template&id=11c89bec&"
import script from "./GestionAccidenteIncidente.vue?vue&type=script&lang=js&"
export * from "./GestionAccidenteIncidente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports